import type React from 'react';

import { AttentionCircleFilledIcon } from '@vlabs/icons';
import { Tooltip } from '@vlabs/uikit';

import { useSideNavLayoutTranslation } from './i18n';
import st from './SideNavLayout.module.sass';

interface SectionErrorIconProps {
  hasError: boolean;
}

// Маркер ошибки валидации у раздела навигации настроек.
function SectionErrorIcon({
  hasError,
}: SectionErrorIconProps): React.JSX.Element | null {
  const { t } = useSideNavLayoutTranslation();

  if (!hasError) return null;

  return (
    <Tooltip
      tooltipContent={t('section_error')}
      tooltipProps={{ place: 'bottom' }}
    >
      <AttentionCircleFilledIcon className={st.ErrorIcon} />
    </Tooltip>
  );
}

export { SectionErrorIcon };
